import {Button, ButtonProps} from '@mui/material';
import {useCallback} from 'react';
import {NavigateOptions, To, useNavigate} from 'react-router';
import {ComponentWithRequiredChildren, PropsWithRequiredChildren} from '../react/types';

type AllowedButtonProps = Omit<ButtonProps, 'onClick'>;
export interface RouteButtonProps extends PropsWithRequiredChildren<AllowedButtonProps>, NavigateOptions {
  to: To;
}

export const RouteButton: ComponentWithRequiredChildren<RouteButtonProps> = ({
  children,
  replace,
  state,
  to,
  variant = 'text',
  ...muiProps
}: RouteButtonProps) => {
  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const onClick = useCallback(() => navigate(to, {replace, state}), [navigate, to, replace, state]);
  return (
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    <Button {...muiProps} onClick={onClick} variant={variant}>
      {children}
    </Button>
  );
};
